import { useQuery } from "@apollo/client";
import useBrazilianIssuer from "components/company/v3/context/hooks/useBrazilianIssuer";
import FinancialHighlightsQuery from "lib/queries/FinancialHighlightsQuery";
import type {
  IFinancialHighlightsQuery,
  IFinancialHighlightsQueryVariables,
} from "lib/queries/__generated__/FinancialHighlightsQuery.generated";
import { useState } from "react";

export default function useBrazilianHighlights() {
  const issuer = useBrazilianIssuer();

  // HIGHTLIGHTS
  const [filterByFinancialHighlightsId, setFilterByFinancialHighlightsId] = useState<string | null>(null);

  const { data: highlightsData, previousData: highlightsPreviousData } = useQuery<
    IFinancialHighlightsQuery,
    IFinancialHighlightsQueryVariables
  >(FinancialHighlightsQuery, {
    variables: {
      issuerId: issuer._id,
      financialHighlightsId: filterByFinancialHighlightsId,
    },
  });

  const highlights = highlightsData ?? highlightsPreviousData;

  return {
    highlights,
    setFilterByFinancialHighlightsId,
  };
}
